import type { CommentHiddenReason } from '@/modules/orders/types/rate-order';

// {{domain}}/api/app/merchants/{{slug}}/reviews?page=1&per_page=10
export const ENDPOINT = (slug: string) => `api/app/merchants/${slug}/reviews`;

// Quantidade de avaliações por página na lista da loja.
export const STORE_REVIEWS_PER_PAGE = 10;

// Resposta pública do estabelecimento a uma avaliação.
export type StoreReviewReply = {
  message: string;
  created_at: string;
};

// Avaliação de um pedido da loja, exibida para qualquer cliente.
export type StoreReview = {
  id: string;
  order_id: string;
  rating: number; // nota de 1 a 5 estrelas
  comment: string | null; // já mascarado pela API; null quando ocultado
  created_at: string;
  customer_name: string; // abreviado pelo backend, ex: "Maria S."
  merchant_reply: StoreReviewReply | null;
  // PRAT-44: comentário ocultado pela loja (a nota continua aparecendo).
  comment_hidden?: boolean;
  comment_hidden_reason?: CommentHiddenReason | null;
};

// Resumo da nota: média e quantidade só dos últimos `period_days` dias.
export type StoreReviewsSummary = {
  average: string; // ex: "4.5" (mesmo formato do `rating` da loja)
  count: number;
  period_days: number;
};

export type GetStoreReviewsRequest = {
  slug: string;
  page?: number;
  per_page?: number;
};

export type GetStoreReviewsResponse = {
  // PRAT-44: false quando a loja não exibe avaliações (summary null, reviews vazio).
  // Ausente na API antiga; a usecase normaliza para true.
  reviews_enabled: boolean;
  // Quantos comentários a loja ocultou (só o texto; a nota segue na lista).
  hidden_comments_count: number;
  summary: StoreReviewsSummary | null;
  reviews: StoreReview[];
  pagination: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
};
